import queryString from 'query-string'
import { safePost, safeGet, safePut, safeDelete, groupsHostUrl } from './http'
import { IMediaType } from '../types/mediaType'

const mediaTypeUrl = `${groupsHostUrl}/media-types`

export const createMediaType = (mediaTypeData: IMediaType) =>
  safePost(mediaTypeUrl, mediaTypeData)

export const getMediaTypes = (params) =>
  safeGet(`${mediaTypeUrl}?${queryString.stringify(params)}`)

export const getMediaTypeByExtension = (extension: string) =>
  safeGet(`${mediaTypeUrl}/${extension}`)

export const updateMediaType = (mediaTypeData: IMediaType) =>
  safePut(`${mediaTypeUrl}/${mediaTypeData.extension}`, mediaTypeData)

export const deleteMediaType = (extension: string) =>
  safeDelete(`${mediaTypeUrl}/${extension}`)
